/**
 * Minimal auth signal for the public site.
 *
 * The cabinet (app.graweo.org) sets a shared, non-httpOnly cookie
 * `graweo_auth=1` on the `.graweo.org` domain when a user is signed in. The
 * public site can only read that cookie — it never manages sessions itself —
 * and uses it to decide whether to show gated content (reports) or the
 * registration wall.
 */
import { useState, useEffect } from 'react';
import { AUTH_COOKIE } from '../config/app';

export function isAuthenticated() {
  if (typeof document === 'undefined') return false;
  return document.cookie
    .split('; ')
    .some((c) => {
      const [name, value] = c.split('=');
      return name === AUTH_COOKIE && value && value !== '0';
    });
}

export function useAuth() {
  const [authed, setAuthed] = useState(() => isAuthenticated());

  useEffect(() => {
    const check = () => setAuthed(isAuthenticated());
    check();
    // Re-check when the tab regains focus (e.g. after logging in on the
    // cabinet in another tab) or becomes visible again.
    window.addEventListener('focus', check);
    document.addEventListener('visibilitychange', check);
    return () => {
      window.removeEventListener('focus', check);
      document.removeEventListener('visibilitychange', check);
    };
  }, []);

  return authed;
}
